var ur = window.location.href;
if(ur.includes('/collections')){
jQuery(document).ready(function(){
for(var i = 0; i < jQuery('.template-collection .product-title').length; i++){
                    
if(jQuery('.bzp-col-bar').eq(i).length == 0){
jQuery('.template-collection .product-title').eq(i).after('<div class="bpz-price-container"><div class="bpz-col-bar"></div></div>')
jQuery('.template-collection .collection .products-grid .box.product').eq(i).append(jQuery('.bpz-price-container').eq(i))
jQuery('.bpz-price-container').eq(i).append(jQuery('span.price').eq(i))
}
if(jQuery('bpz-sale-badge').eq(i).length == 0){
jQuery('.product_card__image-wrapper').eq(i).append('<img class="bpz-sale-badge" src="https://cdn.shopify.com/s/files/1/1926/7025/files/Group_17_1.png?v=1664892818">')
}
           
    
}  
});
}
